module.exports = __webpack_public_path__ + "img/dell-logo.c76b3fa.svg";